import { useEffect, useState } from 'react';
import { windowService } from '../utils/window.utils';
import useSitecoreContext from './useSitecoreContext';

/* eslint-disable-next-line */
const useExperienceEditorPlaceholder = (props: any) => {
  const { sitecoreContext } = useSitecoreContext();
  const isEEActive = sitecoreContext?.pageEditing;
  const isPreview = sitecoreContext?.pageState === 'preview';
  const hasError = !!(props?.fields?.['error'] || props?.fields?.apiData?.['error']);
  const [visitingItemDirectly, setVisitingItemDirectly] = useState(sitecoreContext?.route?.name === '*');
  const isPlaceholderShown = (isEEActive || isPreview) && visitingItemDirectly && hasError;

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(windowService().location?.search);
    const hasItemId = urlSearchParams.get('sc_itemid') !== null;
    setVisitingItemDirectly(hasItemId);
  }, []); // eslint-disable-line

  return isPlaceholderShown;
};

export default useExperienceEditorPlaceholder;
